export default __webpack_public_path__ + "static/media/arrow_shape.7314f994.svg";